const ur = {
    nav: {
      home: "ہوم",
      browse: "شادیاں براؤز کریں",
      dashboard: "ڈیش بورڈ",
      messages: "پیغامات",
      profile: "پروفائل",
      login: "لاگ ان",
      register: "رجسٹر",
      logout: "لاگ آؤٹ",
      admin: "ایڈمن",
      faq: "عام سوالات",
      about: "ہمارے بارے میں",
      contact: "رابطہ",
      pricing: "قیمتیں",
      howItWorks: "یہ کیسے کام کرتا ہے",
    },
    auth: {
      login: {
        title: "واپسی پر خوش آمدید",
        email: "ای میل",
        password: "پاس ورڈ",
        button: "لاگ ان",
        noAccount: "اکاؤنٹ نہیں ہے؟",
        register: "ابھی رجسٹر کریں",
      },
      register: {
        title: "اکاؤنٹ بنائیں",
        name: "مکمل نام",
        email: "ای میل",
        password: "پاس ورڈ",
        role: "میں چاہتا ہوں...",
        roleHost: "شادی کی میزبانی",
        roleGuest: "شادیوں میں شرکت",
        terms: "میں اصول اور پرائیویسی پالیسی قبول کرتا/کرتی ہوں",
        button: "رجسٹر",
        hasAccount: "پہلے سے اکاؤنٹ ہے؟",
        login: "ابھی لاگ ان کریں",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "لود ہو رہا ہے...",
      error: "ایک غلطی ہو گئی",
      success: "کامیاب",
      save: "محفوظ کریں",
      cancel: "منسوخ",
      delete: "حذف کریں",
      edit: "ترمیم",
      back: "واپس",
      next: "اگلا",
      language: "زبان",
      currency: "کرنسی",
      search: "تلاش",
      filter: "فلٹر",
      all: "سب",
      none: "کوئی نہیں",
      yes: "ہاں",
      no: "نہیں",
    },
    footer: {
      about: "ہمارے بارے میں",
      privacy: "پرائیويسی",
      terms: "اضواب",
      contact: "رابطہ",
      copyright: "© 2024 WEDVAYA. جملہ حقوق محفوظ ہیں۔",
    },
  };

export default ur;
